import { useMemo } from 'react';
import { Col, Row, Table, Tooltip, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;


export default props => {

    const {
        notifications,
        onPagniationChange,
        onSortChange,
        pageNo,
        total,
        defaultPageSize,
        navigateToDetails,
    } = props;

    let navigate = useNavigate();

    const columns = useMemo(() => [
        {
            title: 'Sent on',
            dataIndex: 'createdAt',
            key: 'createdAt',
            sorter: true,
            //render: (text, record) => <span>{record.name}</span>
            render: (text, { appZoneCreatedAt, id }) => {

                //console.log('add created at', appZoneCreatedAt)

                return (
                    <a
                        onClick={() => {
                            //console.log('on click', record)
                            navigateToDetails && navigateToDetails(id)
                        }}>
                        {appZoneCreatedAt && appZoneCreatedAt.isValid() && appZoneCreatedAt.format('Do MMMM, YYYY HH:mm')}
                    </a>)

                // return (
                //     <a
                //     onClick={() => {
                //         //console.log('on click', record)
                //         navigate(`/${appRoutes.organisations}/${record.id}`)
                //     }}>
                //         {record.name}
                //     </a>
                // )
            },
        },
        {
            title: 'Template',
            dataIndex: 'template',
            key: 'template',
            render: (text, record) => {

                return (
                    <div style={{ maxWidth: 300 }}>
                        <Tooltip title={record.template}>
                            <Text ellipsis={{
                                rows: 1,
                                expandable: false,
                            }}>
                                {record.template}
                            </Text>
                        </Tooltip>
                    </div>
                )

            }
        },
        {
            title: 'Organisation',
            dataIndex: 'organisation',
            key: 'organisation',
            sorter: true,
        },
        {
            title: 'Recipient(s)',
            dataIndex: 'count',
            key: 'count',
            render: (text, record) => {
                return (
                    <div>
                        <Text>
                            {record.count ? record.count : ''}
                        </Text>
                    </div>
                )
            }
        },
        {
            title: 'Push notifications',
            dataIndex: 'pushNotificationsSent',
            key: 'pushNotificationsSent',
            render: (text, record) => {
                return (
                    <div>
                        <Text>
                            {record.pushNotificationsSent ? "Yes" : 'No'}
                        </Text>
                    </div>
                )
            }
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
        },
    ], [navigate]);

    const onChangeTable = (pagination, filters, sorter, extra) => {
        try {

            // console.log('on change', pagination, filters, sorter, extra);

            if (extra.action === 'paginate') {
                onPagniationChange && onPagniationChange(pagination);
            } else if (extra.action === 'sort') {
                onSortChange && onSortChange(sorter)
            }

        } catch (error) {
            console.log('error on table change', error);
        }
    }

    return (
        <div>
            <Row>
                <Col justify='flex-start' span={24} style={{
                    //padding: '12px',
                    paddingTop: '0px'
                }}>
                    <Table
                        columns={columns}
                        dataSource={notifications}
                        rowKey={'id'}
                        pagination={{
                            current: pageNo + 1,
                            defaultPageSize,
                            //hideOnSinglePage: true,
                            total,
                            pageSizeOptions: []
                        }}
                        onChange={onChangeTable}
                    />
                </Col>
            </Row>
        </div>
    );

}